import { ScopeLevel } from 'constants/ScopeLevel';
import {
  CONTRACT_COMPLIANCE__SCOPE_AGENCY,
  CONTRACT_COMPLIANCE__SCOPE_API_USER,
  CONTRACT_COMPLIANCE__SCOPE_COMPANY,
  CONTRACT_COMPLIANCE__SCOPE_JOINT_COMMISSION,
} from 'translations/constants';

/** The API accepts no other page sizes. */
export const PAGE_SIZE_OPTIONS = [10, 50, 500];
export const INITIAL_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_MS = 300;
export const JUSTIFICATION_MAX_LENGTH = 500;
/** Backend limit for scopeEntityIds on the add call (400 INVALID_VALUE above it). */
export const MAX_SCOPE_ENTITIES_PER_ADD = 1000;
/** Provisional until the PO confirms (backend note). */
export const DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;
/** Allowed justification documents (backend note); also the file picker's `accept` attribute. */
export const DOCUMENT_EXTENSIONS = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];
export const DOCUMENT_ACCEPT_ATTRIBUTE = DOCUMENT_EXTENSIONS.join(',');

/** Panel order, as in the mockup. */
export const SCOPE_LEVELS: ScopeLevel[] = [
  ScopeLevel.JOINT_COMMISSION,
  ScopeLevel.COMPANY,
  ScopeLevel.API_USER,
  ScopeLevel.AGENCY,
];

export const SCOPE_LEVEL_LABEL_KEYS: Record<ScopeLevel, string> = {
  [ScopeLevel.AGENCY]: CONTRACT_COMPLIANCE__SCOPE_AGENCY,
  [ScopeLevel.JOINT_COMMISSION]: CONTRACT_COMPLIANCE__SCOPE_JOINT_COMMISSION,
  [ScopeLevel.COMPANY]: CONTRACT_COMPLIANCE__SCOPE_COMPANY,
  [ScopeLevel.API_USER]: CONTRACT_COMPLIANCE__SCOPE_API_USER,
};
